import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const VideoFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="10" width="48" height="44" rx="8" fill="#E11D48" />
    <path d="M26 23.5v17l16-8.5-16-8.5z" fill="#FFFFFF" />
  </g>,
  'VideoFileIcon',
);
